import { Controller } from "@hotwired/stimulus"
import { withOfflineCleanupLock } from "../offline_download_lock.js"
import { OfflinePdfStore } from "../offline_pdf_store.js"

export default class extends Controller {
  static targets = ["button", "status"]
  static values = { userId: Number, error: String }

  async submit(event) {
    if (this.cleaned) return

    event.preventDefault()
    this.buttonTarget.disabled = true
    this.statusTarget.textContent = ""
    const store = this.createStore()
    try {
      // A paused download must not leave the interactive sign-out button disabled forever.
      const cleaned = await withOfflineCleanupLock(async () => {
        await store.clearUser(this.userIdValue)
        await store.closeDatabase()
        this.cleaned = true
        this.element.requestSubmit()
      }, { ifAvailable: true })
      if (!cleaned) throw new Error("Offline cleanup coordination is unavailable")
    } catch (error) {
      await store.closeDatabase().catch(() => {})
      console.error("Unable to delete offline content before sign out", error)
      this.buttonTarget.disabled = false
      this.statusTarget.textContent = this.errorValue
    }
  }

  createStore() {
    return new OfflinePdfStore()
  }
}
